export { default } from './button';
export { default as buttonConfig } from './button.config';
